import client, { mock, isRealApiEnabled } from "./client";
import iboCartPushResult from "./mocks/iboCart";

/**
 * Push items from the admin context into a specific IBO user's cart.
 *
 * Colour/size must accompany each line: the server resolves them against the
 * NetSuite variant matrix to find a sellable SQL variant. `variationId` alone
 * carries only the colour and is not sufficient.
 *
 * Not idempotent upstream — func-bsm-api inserts a new cart row per call, so
 * re-pushing the same reorder duplicates lines. See KNOWN-LIMITATIONS.md.
 *
 * @endpoint POST /api/v1/ibos/:iboId/users/:userId/cart/items
 * @param {{
 *   iboId: string,
 *   userId: string,
 *   items: Array<{
 *     sku: string, variationId?: string|null, color?: string|null,
 *     size?: string|null, quantity: number, sourceOrderId?: string
 *   }>
 * }} payload
 * @returns {Promise<{
 *   iboId: string,
 *   userId: string,
 *   cartId: string|null,
 *   accepted: Array<object>,
 *   skipped: Array<object>,
 *   cartItemCount: number,
 *   pushedAt: string,
 *   simulated?: boolean
 * }>}
 */
export function pushItems(payload) {
  if (isRealApiEnabled()) {
    return client.post(
      `/v1/ibos/${payload.iboId}/users/${payload.userId}/cart/items`,
      { items: payload.items }
    );
  }
  return mock({
    ...iboCartPushResult,
    iboId: (payload && payload.iboId) || iboCartPushResult.iboId,
    userId: (payload && payload.userId) || iboCartPushResult.userId,
    accepted: (payload && payload.items) || iboCartPushResult.accepted,
    skipped: [],
    cartItemCount: ((payload && payload.items) || iboCartPushResult.accepted)
      .length,
    pushedAt: new Date().toISOString(),
  });
}
